import React, { Component } from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import { Grid, Row, Col } from "react-bootstrap";
import Select from 'react-select';

import { CustomCard } from "../../components/Card/CustomCard";

import Usuarios from "./Usuarios";

class MainRegistrosAdmin extends Component {
    state = {
        valorRegistro: { value: 'usuarios', label: 'Usuarios' },
    }

    Selecciona = (link) => {
        switch (link) {
            case "/registros_admin/usuarios":
                return({ value: 'usuarios', label: 'Usuarios' })
            default:
                return({ value: 'usuarios', label: 'Usuarios' })
        }
    }

    valorRegistroLabel = (link) => {
        switch (link) {
            case "/registros_admin/usuarios": return('Usuarios')
            default: return('Usuarios')
        }
    }


    valorSelectRegistro = (valorRegistro) => {
        this.setState({
            valorRegistro
        },() => {
            this.props.history.push(`/registros_admin/${this.state.valorRegistro.value}`);
        });
    }
    
    contenido = () => {
        return (
            <Switch>
                <Route path="/registros_admin/usuarios" component={ () => <Usuarios/> } />
                <Redirect to = "/registros_admin/usuarios" />
            </Switch>
        )
    }

    render() {
        const Registros = [
            { value: 'usuarios', label: 'Usuarios' },
        ];

        return (
            <div className="content">
                <Grid fluid>
                    <div className="custom-alert-info" style={{marginBottom:15, padding:5}}>
                        <Row>
                            <Col md={9}>
                                <div className="title" style={{fontSize:14, paddingTop: 10}}>
                                    Selecciona el tipo de Registro
                                </div>
                            </Col>
                            <Col md={3}>
                                <Select
                                    isSearchable ={true}
                                    value={this.Selecciona(this.props.history.location.pathname)}
                                    onChange={this.valorSelectRegistro}
                                    options={Registros}
                                />
                            </Col>
                        </Row>
                    </div>
                    <Row>
                        <Col md={12}>
                            <CustomCard
                                title={`Opciones de ${this.valorRegistroLabel(this.props.history.location.pathname)}`}
                                category=""
                                color="#a80012"
                                content={this.contenido()}
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}
 
export default MainRegistrosAdmin;


// WEBPACK FOOTER //
// ./src/views/Registros/MainRegistrosAdmin.jsx